<template>
  <div class="paypage">
    <div class="payname">
      <div class>
        <span>{{userinfo.Name}}</span>
        <span>{{userinfo.CardNumber}}</span>
        <span class="cor" @click="switchPerson">切换就诊人</span>
        <span class="needle">></span>
      </div>
    </div>
    <div class="paytime">
      <span>就诊时间：</span>
      <span class="sel" @click="checkPickerOption">{{timeType}}</span>
    </div>
    <div v-show="isShow">
      <div class="paydeteil" v-for="item in visitList">
        <div>
          <p class="pensontit">
            <img src="../../assets/images/penson.png" alt class="pensonpic">
            <span>{{item.PatName}}</span>
            <span>{{item.Code}}</span>
            <span class="fontblue" @click="satisfactionDeteil(item.GUID,item.HosID)">查看详情</span>
            <span class="smallicon">></span>
          </p>
          <div class="pd20">
            <p>
              <span>就诊科室：</span>
              <span>{{item.DptName}}</span>
            </p>
            <p>
              <span>就诊医生：</span>
              <span>{{item.DctName}}</span>
            </p>
            <p>
              <span>就诊日期:</span>
              <span class="mr18">{{item.VisitTime}}</span>
            </p>
            <span class="statuspos statusgreen">{{item.StateName}}</span>
          </div>
        </div>
      </div>
    </div>
    <div class="noDate" v-show="!isShow">
      <div v-show="true" class="nolist">
        <!-- 无数据显示 -->
        <img src="../../assets/images/searchbg.png" alt class="searchpic">
        <p class="center">暂无数据</p>
      </div>
    </div>
  </div>
</template>
<
<script>
  import { GetVisits } from "@/services/getData.js";
  import weui from 'weui.js';
  import _ from 'lodash';
  export default {
    name: 'satisfaction-query',
    data() {
      return {
        timeType: '七天内',
        userinfo: {},
        visitList: {},
        isShow:true
      };
    },
    created: function () {
      this.userinfo = this.$store.state.userInfo;
      this.getVisits();
    },
    methods: {
        checkPickerOption: function() {
       var _that=this;
      weui.picker(
        [
          {
            label: "七天内",
            value: 0
          },
          {
            label: "三个月内",
            value: 1
          },
           {
            label: "半年内",
            value: 2
          }
        ],
        {
          onChange: function(result) {
            // console.log(result);
          },
          onConfirm: function(result) {
            _that.timeType=result['0']['label'];
          
          }
        }
      );
    },
      satisfactionDeteil(guid,hosid) {
        this.$router.push({ path: "/satisfaction/deteil", query: { visitID: guid, hosid: hosid } });
      },
      switchPerson() {
        this.$router.push({ path: "/card/switchcard", params: { userId: 123 } });
      },
      getVisits() {
        var loading = weui.loading('loading', {
          className: 'custom-classname',
          content: '加载中'
        });
        GetVisits(this.timeType).then((response) => {
          loading.hide();
          if (response.data) {
                this.visitList = _.filter(response.data, function (item) {
                return item.State == 2;
            });
            if(this.visitList.length>0)
            {
              this.isShow=true;
            }
            else
            {
              this.isShow=false;
            }
          }
          else {

          }
        });

      }
    },

  }
</script>
<style>
.paypage {
  width: 100%;
  height: 100%;
}

.paypage .payname {
  width: 100%;
  height: 0.8rem;
  background: rgba(21, 146, 228, 1);
  padding: 0 0.2rem;
  font-size: 0.22rem;
  font-family: MicrosoftYaHei;
  font-weight: 400;
  color: rgba(255, 255, 255, 1);
  line-height: 0.8rem;
  box-sizing: border-box;
}

.payname > div {
  position: relative;
}

.paypage .payname .cor {
  color: #feff82 !important;
  float: right;
  margin-right: 0.4rem;
}

.paypage .needle {
  font-size: 0.31rem;
  font-family: MicrosoftYaHei;
  position: absolute;
  right: 0;
  top: -0.02rem;
}

select {
  outline: none;
  border: 0;
  height: 0.4rem;
  background: rgba(255, 255, 255, 1);
  border-radius: 0.2rem;
  width: auto;
  padding: 0 0.3rem;
}

.paypage .paytime {
  padding: 0.2rem;
  height: auto;
  font-size: 0.22rem;
  font-family: MicrosoftYaHei;
  font-weight: 400;
  color: rgba(51, 51, 51, 1);
}

.paypage .paydeteil {
  background: white;
  padding: 0 0.2rem;
  font-size: 0.24rem;
  font-family: MicrosoftYaHei;
  font-weight: 400;
  color: rgba(51, 51, 51, 1);
  line-height: 0.36rem;
  margin-bottom: 0.2rem;
}

.paypage .paydeteil .pensontit {
  border-bottom: 0.01rem solid rgba(221, 221, 221, 1);
  position: relative;
  box-sizing: border-box;
  padding-top: 0.2rem;
  padding-bottom: 0.18re;
  padding-bottom: 0.14rem;
}

.paypage .paydeteil .pensontit .pensonpic {
  width: 0.22rem;
  height: 0.28rem;
  display: inline-block;
  vertical-align: text-top;
}

.paypage .paydeteil .pensontit .fontblue {
  color: rgba(21, 146, 228, 1) !important;
  float: right;
  margin-right: 0.4rem;
}

.paypage .paydeteil .pensontit .smallicon {
  font-size: 0.31rem;
  font-family: MicrosoftYaHei;
  position: absolute;
  right: 0;
}

.paypage .paydeteil .pd20 {
  padding: 0.2rem 0;
  box-sizing: border-box;
}

.mr18 {
  margin-left: 0.18rem;
}
.paypage .sel {
  width: 1.5rem;
  height: 0.4rem;
  background: rgba(255, 255, 255, 1);
  border-radius: 0.2rem;
  line-height: 0.4rem;
  /* text-align: center; */
  display: inline-block;
  position: relative;
  box-sizing: border-box;
  padding-left: 0.2rem;
}
.paypage .sel::after {
  position: absolute;
  display: inline-block;
  content: "";
  right: 0.18rem;
  width: 0;
  height: 0rem;
  border-width: 0.11rem 0.07rem;
  border-style: solid;
  border-color: #333333 transparent transparent transparent;
  font-size: 0.18rem;
  color: #fefefe;
  top: 0.15rem;
}
</style>



// WEBPACK FOOTER //
// src/components/satisfaction/satisfaction-query.vue